import { createFileRoute, Link } from "@tanstack/react-router";
import {
  GraduationCap,
  ArrowLeft,
  CheckCircle2,
  ShieldCheck,
  Calendar,
  ExternalLink,
  Lock,
  ListChecks,
  Users,
  
  FlaskConical,
  Trophy,
  IdCard,
} from "lucide-react";
import { AdminGate } from "@/components/admin/AdminGate";

export const Route = createFileRoute("/admin/plano-bolsas-feo")({
  head: () => ({
    meta: [
      { title: "Admin — Plano · Bolsas FEO 2026" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminGate route="/admin/plano-bolsas-feo">
      <PlanoBolsasFeoPage />
    </AdminGate>
  ),
});

const CRONOGRAMA = [
  { data: "23/06", titulo: "Inscrições abertas (RD Station)", status: "feito" as const },
  { data: "02/07", titulo: "Inscrições encerradas", status: "feito" as const },
  { data: "05/07", titulo: "Prova online (/bolsas-feo-prova) — 2h máx.", status: "feito" as const },
  { data: "06–13/07", titulo: "Correção e seleção dos 10 contemplados", status: "feito" as const },
  { data: "14/07", titulo: "Divulgação dos resultados (CPF na página + WhatsApp do nosso time)", status: "feito" as const },
];


function PlanoBolsasFeoPage() {
  return (
    <div className="min-h-screen">
      <div className="mx-auto max-w-4xl px-4 py-12 md:py-16 space-y-8">
        <Link to="/admin" className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-3.5 w-3.5" /> voltar ao centro de controle
        </Link>

        <header className="text-center space-y-4 py-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-emerald-600 dark:text-emerald-300">
            <CheckCircle2 className="h-3.5 w-3.5" /> Concluído · Resultados divulgados
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground">
            Programa Bolsas FEO 2026
          </h1>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto px-2">
            10 bolsas integrais (100%) para fisioterapeutas. Inscrições, prova, correção e seleção
            <strong> concluídas</strong>. Os contemplados estão publicados em{" "}
            <code className="text-xs bg-secondary/50 px-1 rounded">/bolsas-feo-resultados</code>
            {" "}apenas com os 4 últimos dígitos do CPF (LGPD); o contato oficial é feito pelo nosso
            time via WhatsApp.
          </p>
        </header>

        <div className="rounded-2xl border border-primary/30 bg-primary/5 p-5 sm:p-6">
          <div className="flex items-start gap-3">
            <Lock className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <div>
              <h3 className="font-bold text-base mb-1">Escopo no Lovable</h3>
              <p className="text-sm text-muted-foreground">
                A captação de leads continua na{" "}
                <a
                  href="https://materiais.fisioemortopedia.com.br/bolsas-feo-2026"
                  target="_blank"
                  rel="noreferrer"
                  className="underline"
                >
                  LP do RD Station
                </a>
                . Aqui mantemos: prova em{" "}
                <code className="text-xs bg-secondary/50 px-1 rounded">/bolsas-feo-prova</code>, página
                pública de cronograma/resultados em{" "}
                <code className="text-xs bg-secondary/50 px-1 rounded">/bolsas-feo-resultados</code> e
                painel admin em{" "}
                <code className="text-xs bg-secondary/50 px-1 rounded">/admin/bolsas-feo</code>.
                Ambas as páginas públicas estão com <code className="text-xs bg-secondary/50 px-1 rounded">noindex</code>.
              </p>
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-border bg-card p-5 sm:p-6">
          <h3 className="font-bold text-lg mb-4 flex items-center gap-2"><Calendar className="h-5 w-5 text-primary" /> Cronograma 2026</h3>
          <div className="grid gap-2 sm:grid-cols-2">
            {CRONOGRAMA.map((c) => {
              const accent = c.status === "feito" ? "emerald" : c.status === "andamento" ? "amber" : "slate";
              const colorClass = accent === "emerald" ? "border-emerald-500/30 bg-emerald-500/5" : accent === "amber" ? "border-amber-500/30 bg-amber-500/5" : "border-border bg-background/50";
              return (
                <div key={c.data} className={`rounded-xl border p-3 flex items-center gap-3 ${colorClass}`}>
                  <div className="font-mono text-sm font-bold tabular-nums">{c.data}</div>
                  <div className="text-sm flex-1">{c.titulo}</div>
                  {c.status === "feito" && <CheckCircle2 className="h-4 w-4 text-emerald-500" />}
                </div>
              );
            })}
          </div>
        </div>

        {/* Páginas e painéis */}
        <div className="grid gap-4 sm:grid-cols-2">
          <Link to="/admin/bolsas-feo" className="rounded-2xl border border-border bg-card p-5 hover:border-primary/40 hover:bg-card/80 transition-colors group">
            <Users className="h-5 w-5 text-primary mb-2" />
            <h3 className="font-bold text-base">Painel · Bolsas FEO</h3>
            <p className="text-xs text-muted-foreground mt-1">
              Whitelist de inscritos (com CPF + flag de teste) e provas enviadas (nota, respostas,
              gabarito, duração, flag teste). Exporta CSV completo.
            </p>
            <code className="text-[11px] text-muted-foreground block mt-2">/admin/bolsas-feo</code>
            <span className="mt-3 inline-flex items-center text-xs font-semibold text-primary">
              abrir painel <ExternalLink className="h-3 w-3 ml-1 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </Link>

          <a href="/bolsas-feo-prova" target="_blank" rel="noreferrer" className="rounded-2xl border border-border bg-card p-5 hover:border-primary/40 hover:bg-card/80 transition-colors group">
            <ShieldCheck className="h-5 w-5 text-primary mb-2" />
            <h3 className="font-bold text-base">Página pública da prova</h3>
            <p className="text-xs text-muted-foreground mt-1">
              Explica cronograma, regras e libera a prova mediante CPF cadastrado. 1 envio por CPF
              (inscritos de teste podem repetir).
            </p>
            <code className="text-[11px] text-muted-foreground block mt-2">/bolsas-feo-prova</code>
            <span className="mt-3 inline-flex items-center text-xs font-semibold text-primary">
              abrir página <ExternalLink className="h-3 w-3 ml-1 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>

          <a href="/bolsas-feo-resultados" target="_blank" rel="noreferrer" className="rounded-2xl border border-border bg-card p-5 hover:border-primary/40 hover:bg-card/80 transition-colors group">
            <Trophy className="h-5 w-5 text-primary mb-2" />
            <h3 className="font-bold text-base">Página oficial de resultados</h3>
            <p className="text-xs text-muted-foreground mt-1">
              Publica a lista dos 10 contemplados mostrando apenas os 4 últimos dígitos do CPF
              (LGPD), o cronograma concluído e os contatos de WhatsApp do time.
            </p>
            <code className="text-[11px] text-muted-foreground block mt-2">/bolsas-feo-resultados</code>
            <span className="mt-3 inline-flex items-center text-xs font-semibold text-primary">
              abrir página <ExternalLink className="h-3 w-3 ml-1 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>

          <a href="https://materiais.fisioemortopedia.com.br/bolsas-feo-2026" target="_blank" rel="noreferrer" className="rounded-2xl border border-border bg-card p-5 hover:border-primary/40 hover:bg-card/80 transition-colors group">
            <GraduationCap className="h-5 w-5 text-primary mb-2" />
            <h3 className="font-bold text-base">LP de inscrições (RD Station)</h3>
            <p className="text-xs text-muted-foreground mt-1">
              Captação oficial dos candidatos. Após 02/07 o CSV é exportado e importado no painel admin.
            </p>
            <span className="mt-3 inline-flex items-center text-xs font-semibold text-primary">
              abrir LP <ExternalLink className="h-3 w-3 ml-1 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>
        </div>

        {/* Fluxo */}
        <div className="rounded-2xl border border-border bg-card p-5 sm:p-6">
          <h3 className="font-bold text-lg mb-4 flex items-center gap-2"><ListChecks className="h-5 w-5 text-primary" /> Fluxo atualizado (acesso por CPF)</h3>
          <ol className="space-y-3 text-sm">
            {[
              {
                t: "Whitelist server-side com CPF",
                d: "Em /admin/bolsas-feo a equipe importa (CSV) ou cadastra os inscritos autorizados. O CPF é a chave de acesso à prova; o e-mail e WhatsApp ficam vinculados para contato.",
              },
              {
                t: "Identificação por CPF na prova",
                d: "Em /bolsas-feo-prova o candidato lê o cronograma e digita o CPF. O servidor valida (checksum + whitelist) e bloqueia tentativas duplicadas via UNIQUE index em cpf_digits.",
              },
              {
                t: "25 questões, todas obrigatórias",
                d: "Renderizadas pelo servidor sem o gabarito. Progresso salvo no localStorage por CPF para resistir a refresh; alerta no beforeunload. Envio só libera quando todas estão respondidas.",
              },
              {
                t: "Correção e gravação no banco",
                d: "Cálculo no servidor com gabarito secreto. Salvamos em bolsa_feo_submissions: nome, email, telefone, cpf, cpf_digits, respostas (jsonb), score, total, correct_ids, duration_seconds, is_test e timestamp. Nada se perde.",
              },
              {
                t: "Confirmação sem nota",
                d: "Candidato vê apenas 'prova registrada' + reforço de que a comunicação será exclusivamente via WhatsApp em 14/07. Link para /bolsas-feo-resultados.",
              },
              {
                t: "Página de resultados com CPF mascarado",
                d: "A página /bolsas-feo-resultados publica a lista oficial dos 10 contemplados exibindo apenas os 4 últimos dígitos do CPF (formato XXX.XXX.NNN-NN, conforme LGPD). O contato individual com passo a passo da matrícula é feito pelo nosso time via WhatsApp.",
              },

              {
                t: "Admin com filtros e export",
                d: "Em /admin/bolsas-feo a tabela secreta mostra todas as submissões (nome, e-mail, CPF, WhatsApp, nota, duração, respostas vs gabarito), com toggle 'ocultar testes' e export CSV completo com is_test.",
              },
            ].map((s, i) => (
              <li key={i} className="flex gap-3 rounded-xl border border-border bg-background/50 p-3">
                <div className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-primary/10 text-primary font-bold text-xs">{i + 1}</div>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-sm">{s.t}</div>
                  <p className="text-xs text-muted-foreground mt-1">{s.d}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        {/* Acesso de teste */}
        <div className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-5 sm:p-6">
          <h3 className="font-bold text-base mb-2 flex items-center gap-2 text-amber-700 dark:text-admin-accent">
            <FlaskConical className="h-4 w-4" /> Modo de acesso de teste
          </h3>
          <p className="text-sm text-muted-foreground">
            Em <Link to="/admin/bolsas-feo" className="underline">/admin/bolsas-feo</Link> você pode
            cadastrar inscritos marcando o checkbox{" "}
            <strong className="text-amber-700 dark:text-admin-accent">Inscrito de teste</strong>. Esses
            CPFs ignoram o limite de 1 envio: você pode submeter a prova quantas vezes quiser, com
            respostas diferentes, e cada execução é salva como uma linha nova com{" "}
            <code className="text-xs bg-secondary/50 px-1 rounded">is_test = true</code> — não polui as
            estatísticas reais.
          </p>
          <ul className="text-xs text-muted-foreground mt-3 space-y-1">
            <li>• Cadastre múltiplos CPFs de teste (use geradores de CPF válido) para simular cenários.</li>
            <li>• Use o toggle "ocultar testes" no painel para ver apenas os envios reais.</li>
            <li>• Antes do dia 05/07, remova ou esvazie os testes pelo botão "remover" individual.</li>
          </ul>
        </div>

        {/* Modelo de dados */}
        <div className="rounded-2xl border border-border bg-card p-5 sm:p-6">
          <h3 className="font-bold text-base mb-2 flex items-center gap-2"><IdCard className="h-4 w-4 text-primary" /> Modelo de dados</h3>
          <ul className="text-xs text-muted-foreground space-y-1.5">
            <li>
              • <code className="bg-secondary/50 px-1 rounded">bolsa_feo_inscritos</code>: whitelist
              (nome, email, telefone, cpf, cpf_digits gerado, is_test, notes).
            </li>
            <li>
              • <code className="bg-secondary/50 px-1 rounded">bolsa_feo_submissions</code>: submissões
              (inscrito_id FK, nome, email, telefone, cpf, cpf_digits, respostas jsonb, score, total,
              correct_ids, duration_seconds, is_test, submitted_at).
            </li>
            <li>
              • <code className="bg-secondary/50 px-1 rounded">idx_bolsa_feo_subs_cpf_unique</code>:
              índice UNIQUE parcial em <code>cpf_digits WHERE is_test = false</code> — garante que cada
              CPF real envie apenas uma vez, mas permite reenvios em modo teste.
            </li>
          </ul>
        </div>

        {/* Próximos passos */}
        <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-5 sm:p-6">
          <h3 className="font-bold text-base mb-2 flex items-center gap-2 text-emerald-700 dark:text-emerald-300">
            <CheckCircle2 className="h-4 w-4" /> Etapas concluídas
          </h3>
          <ul className="text-sm text-muted-foreground space-y-1.5">
            <li>• Inscrições encerradas em 02/07 e whitelist importada em <Link to="/admin/bolsas-feo" className="underline">/admin/bolsas-feo</Link>.</li>
            <li>• Prova aplicada em 05/07 via <code className="text-xs bg-secondary/50 px-1 rounded">/bolsas-feo-prova</code>.</li>
            <li>• Correção automática + revisão manual dos empates → 10 contemplados selecionados.</li>
            <li>• Em 14/07: página <code className="text-xs bg-secondary/50 px-1 rounded">/bolsas-feo-resultados</code> atualizada com a lista de CPFs mascarados e contato individual via WhatsApp do nosso time.</li>
          </ul>
        </div>

        <footer className="text-center py-8 text-xs text-muted-foreground">
          /admin/plano-bolsas-feo · projeto em andamento
        </footer>
      </div>
    </div>
  );
}
